<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { helloInit, checkDays } from '@/utils/getTime.js'
export default {
  name: 'App',
  data() {
    return {
    }
  },
  mounted() {
  // 欢迎提示
    helloInit()
    // 默哀模式
    checkDays()
    const _this = this
    document.onkeydown = function(e) {
      _this.keyMethod()
    }
    window.addEventListener('load', () => {
      // 去除加载标记
      document.getElementsByTagName('body')[0].className = ''
      // 给加载动画添加结束标记
      const loadingBox = document.getElementById('loading-box')
      loadingBox.classList.add('loaded')
    })

    // 屏蔽右键
    document.oncontextmenu = () => {
      this.$message({
        message: '为了浏览体验，本站禁用右键',
        duration: 2000
      })
      return false
    }

    // 监听当前页面宽度
    this.getWidth()
    window.addEventListener('resize', this.getWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWidth)
  },
  methods: {
    getWidth() {
      this.$store.commit('setInnerWidth', window.innerWidth)
    },
    keyMethod(e) {
      const key = window.event.keyCode
      console.log(key)

      if (event.ctrlKey && event.shiftKey) {
        window.event.preventDefault()
        switch (key) {
          case 88:
            // ctrl + shift + x
            console.log(key, '按下了ctrl + shift + x')
            this.$store.commit('updateProjectType', 'special')
            break
          case 65:
            // ctrl + shift + a
            console.log(key, '按下了ctrl + shift + a')
            this.$store.commit('updateProjectType', 'normal')
            break
          default:
            console.log('按下了', key)
            break
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue